(function () {

    'use strict';

    angular.module('breakmarkApp').controller('CustomPaymentGeneratorFormCtrl', ['$rootScope', '$scope', '$window', function($rootScope, $scope, $window) {

        $scope.customerPaymentGeneratorForm = {};
        $scope.generatedURL = '';

        $scope.$watch('customerPaymentGeneratorForm', function(form){
            makeURL(form)
        }, true);

        function makeURL(form){

            let url = location.protocol + '//' + location.host + '/#/custom-payment?';

            if(form.customer_name){
                url += 'customer_name=';
                url += $window.encodeURIComponent(form.customer_name);
                url += '&';
            }

            if(form.customer_organization){
                url += 'customer_organization=';
                url += $window.encodeURIComponent(form.customer_organization);
                url += '&';
            }

            if(form.customer_note){
                url += 'customer_note=';
                url += $window.encodeURIComponent(form.customer_note);
                url += '&';                
            }

            if(form.amount){
                url += 'amount=';
                url += $window.encodeURIComponent(form.amount);
            }

            console.log('url', url);

            $scope.generatedURL = url;
        }

    }]);
})();
